var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_11280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2803 4.12903L10.3753 2.22366C10.2346 2.08303 10.0434 2.00391 9.84501 2.00391H3.15538C2.95663 2.00391 2.76576 2.08303 2.62513 2.22366L0.720131 4.12903C0.572756 4.27603 0.499256 4.46991 0.500006 4.66416C0.501131 4.84041 0.564131 5.01628 0.689756 5.15766L5.93938 10.7482C6.08188 10.9087 6.28588 11.0002 6.50001 11.0002C6.71413 11.0002 6.91813 10.9087 7.06026 10.7482L12.3103 5.15766C12.4385 5.01328 12.5015 4.83253 12.5 4.65216C12.4985 4.46241 12.4246 4.27341 12.2803 4.12903ZM7.33213 4.62891H5.66751L6.50001 3.93553L7.33213 4.62891ZM6.79326 3.69141L7.81776 2.83716L8.57451 3.59391L7.62501 4.38478L6.79326 3.69141ZM5.37501 4.38478L4.42551 3.59391L5.18226 2.83716L6.20713 3.69141L5.37501 4.38478ZM7.43376 5.00391L6.50001 9.67378L5.56626 5.00391H7.43376ZM7.81626 5.00391H9.65601L6.89638 9.60478L7.81626 5.00391ZM7.91713 4.62891L8.84076 3.85978L9.60988 4.62891H7.91713ZM8.26513 2.75391H9.58213L8.86363 3.35278L8.26513 2.75391ZM6.50001 3.44766L5.66751 2.75391H7.33176L6.50001 3.44766ZM4.13601 3.35278L3.41751 2.75391H4.73488L4.13601 3.35278ZM4.15926 3.85978L5.08251 4.62891H3.39013L4.15926 3.85978ZM5.18376 5.00391L6.10363 9.60478L3.34363 5.00391H5.18376ZM5.26401 8.93316L1.57401 5.00391H2.90676L5.26401 8.93316ZM10.0933 5.00391H11.4264L7.73563 8.93391L10.0933 5.00391ZM10.1401 4.62891L9.13026 3.61903L9.99163 2.90091L11.7193 4.62891H10.1401ZM3.00726 2.90016L3.87013 3.61903L2.85988 4.62891H1.25226L3.00726 2.90016Z",
    fill: "#15803D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_11280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondLang);
export default __webpack_public_path__ + "static/media/diamond_lang.960a9eda36b573c7d4c50343caa97c00.svg";
export { ForwardRef as ReactComponent };